import { Link } from "react-router-dom";

import { Box, Text, Button, Link as ShopifyLink } from '@shopify/polaris';

const NoLabelTemplatesBox = ({ }) => {
  return(
    <Box
      background="bg-surface-caution"
      borderColor="border" 
      borderWidth="025"
      borderRadius="100"
      padding="400"
      shadow="300"
    >
      <Text variant="headingSm" as="h6">Create Label Template</Text>
      <Text as="p" tone="caution">
        You don't have any label templates saved.
      </Text>
      <ShopifyLink external url="https://athousandapps.com/shopify/manage-barcode-label-templates-3/">
        Read about label templates
      </ShopifyLink>
      <br/>
      <br/>
      <Link to={`/templates/new${window.location.search}`}>
        <Button variant="primary">Create a label template</Button>
      </Link>
    </Box>
  )
}

export default NoLabelTemplatesBox;
